// extracted by mini-css-extract-plugin
export default {"main":"styles__main__ievLx","hidden-link":"styles__hidden-link__sjDcW","hiddenLink":"styles__hidden-link__sjDcW"};